// Vue Components
import Vue from "vue";
import App from "./App.vue";

import { auth } from './plugins/firebase'
import { onAuthStateChanged } from "firebase/auth";

// Vue Router
import router from "./plugins/router";

// Font Awesome
import "./plugins/fontawesome";

// Vuex
import store from "./plugins/store";

//Filter
import { currency } from "./plugins/filters";

// Bootstrap
import BootstrapVue from "bootstrap-vue";
import { BootstrapVueIcons } from 'bootstrap-vue'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@comlinedev/bootstrap4/dist/css/bootstrap.css";
Vue.use(BootstrapVue)
  .use(BootstrapVueIcons);

// Hide Production Tip
Vue.config.productionTip = false;

// App Init
onAuthStateChanged(auth, () => {
  let app = "";
  if (!app) {
    Vue.filter("currency", currency);
    app = new Vue({
      render: (h) => h(App),
      router,
      store,
    }).$mount("#app");
  }
});
